import { Typography, Divider, Box } from "@mui/material";

const XadamatFani = () => {
  return (
    <>
      <Box sx={{ paddingLeft: 2 }}>
        <Typography variant="h2" sx={{ fontSize: "2rem", margin: 3 }}>
          خدمات فنی و مهندسی
        </Typography>
        <Typography sx={{ fontSize: "1.2rem", margin: 2 }}>
          این واحد کار مشاوره ، طراحی ، نصب ، اجرا و راه اندازی پروژه های صنعتی
          را برعهده دارد.
        </Typography>
        <Typography sx={{ fontSize: "1.3rem", margin: 2 }}>
          پروژه هایی از قبیل:
        </Typography>
        <Typography variant="subtitle1" sx={{ fontSize: "1.10rem", margin: 2 }}>
          <ul>
            <li style={{ fontFamily: "Homa,Ubunto" }}>
              سیستم های کنترل مبتنی بر{" "}
              <span style={{ fontFamily: "roboto" }}>PLC , PC</span>
            </li>
            <li> سیستم های کنترل ، مانیتورینگ ، ثبت اطلاعات و گزارش گیری </li>
            <li> تله متری و اسکادا </li>
            <li> ابزاردقیق </li>
          </ul>
        </Typography>
        <Divider />
        <Typography sx={{ fontSize: "1.3rem", margin: 2 }}>
          خدمات مهندسی قابل ارائه در پروژه ها توسط این واحد عبارتند از :
        </Typography>
        <Typography variant="subtitle1" sx={{ fontSize: "1.10rem", margin: 2 }}>
          <ul>
            <li>بازدید از پروژه و برآورد هزینه لازم جهت احقاق آن</li>
            <li>
              طراحی و انتخاب سخت افزار ، نرم افزار و پیکربندی مناسب{" "}
              <span style={{ fontFamily: "roboto" }}>PLC</span> و شبکه های صنعتی
              مربوطه
            </li>
            <li>
              ارائه لیست خرید تجهیزات و واردات لازم برای اجرای پروژه و همکاری در
              تهیه آنها
            </li>
            <li style={{ fontFamily: "Homa,Ubunto" }}>
              تهیه نقشه عملیاتی طرح و نقشه سیم بندی و مونتاژ تابلوها
            </li>
            <li style={{ fontFamily: "Homa,Ubunto" }}>
              مونتاژ تابلو های قدرت و{" "}
              <span style={{ fontFamily: "roboto" }}>PLC</span> و تست کارگاهی
            </li>
            <li>نصب ، تست ، راه اندازی ، آموزش و تحویل سیستم</li>
            <li>
              {" "}
              ارائه نسخه های پشتیبان و مدارک فنی تجهیزات استفاده شده در پروژه
            </li>
          </ul>
        </Typography>
      </Box>
    </>
  );
};
export default XadamatFani;
